import { Partial } from '@40seas/entities/common';
import { InsuranceCover } from './insurance.covers.entity';

export class UpdateInsuranceCoverDto extends Partial(InsuranceCover) {}
